/* template */
<template><mpx-image mode="heightFix" :src="(sloganIcon)" class="slogan"/></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mee4c3584"}'>
  .slogan
    display block
    height 35px
    margin 0 auto 20px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mee4c3584"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexee4c3584%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexee4c3584%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mee4c3584"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexee4c3584/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
